import React, {  useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'

import Container from "@material-ui/core/Container"
import Card from '@material-ui/core/Card'
import Grid from '@material-ui/core/Grid'
import CardActionArea from '@material-ui/core/CardActionArea'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'

import { Link } from './Link'
import { ROUTES_BY_ID as RouteDictionary } from '../constants/routes'
import { styleConstants } from '../constants/style'

import { _t } from '../i18n/lang'

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
	faUserPlus,
	faUsers,
	faList,
	faShieldAlt,
} from '@fortawesome/free-solid-svg-icons'


const useStyles = makeStyles({
	root: {
		maxWidth: 345,
	},
	media: {
		height: 140,
	},
	containerWrap: {
		paddingTop: '40px',
	},
	link: {
		fontSize: '18px',
		color: styleConstants.LINK_COLOR,
		padding: '0px 5px'
	},
	actionWrap: {
		padding: '5px 16px',
		textAlign: 'center',
		display: 'block',
	},
	iconWrap: {
		padding: '10px 5px 5px',
		fontSize: '50px',
		textAlign: 'center',
		color: styleConstants.ICON_COLOR,
	}
});
export default function Canon() {
	const classes = useStyles();
	const spacing = 6;

	return (
		<Container className={classes.containerWrap}>
			<Grid sx={{ flexGrow: 1 }} container spacing={2}>
				<Grid item xs={12}>
					<Grid container justify={'center'}  spacing={spacing}>
						<Grid item xs={2} >
							<Card className={classes.root}>
								<CardActionArea>
									<Link to={RouteDictionary.customers.path}
												as='button'
												size="small"
												color="primary"
												className={classes.link}
									>
										<div className={classes.iconWrap}>
											<FontAwesomeIcon icon={faUsers} />
										</div>

										<CardContent>
											<Typography gutterBottom variant="h5" component="h2" align={'center'}>
												{_t('MMR_DASHBOARD_CARD_CUSTOMERS_HEADER')}
											</Typography>
										</CardContent>
									</Link>
								</CardActionArea>
							</Card>
						</Grid>

						<Grid item xs={2}>
							<Card className={classes.root}>
								<CardActionArea>
									<Link to={RouteDictionary.current_orders.path}
												as='button'
												size="small"
												color="primary"
												className={classes.link}
									>
										<div className={classes.iconWrap}>
											<FontAwesomeIcon icon={faList} />
										</div>

										<CardContent>
											<Typography gutterBottom variant="h5" component="h2" align={'center'}>
												{_t('MMR_DASHBOARD_CARD_CURRENT_ORDERS_HEADER')}
											</Typography>
										</CardContent>
									</Link>
								</CardActionArea>
							</Card>
						</Grid>

						<Grid item xs={2}>
							<Card className={classes.root}>
								<CardActionArea>
									<Link to={RouteDictionary.orders.path}
												as='button'
												size="small"
												color="primary"
												className={classes.link}
									>
										<div className={classes.iconWrap}>
											<FontAwesomeIcon icon={faShieldAlt} />
										</div>

										<CardContent>
											<Typography align={'center'} gutterBottom variant="h5" component="h2">
												{_t('MMR_DASHBOARD_CARD_WARRANTIES_HEADER')}
											</Typography>
										</CardContent>
									</Link>
								</CardActionArea>
							</Card>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Container>
	)
}
